import CountUp from "react-countup";
import styles from "./ensoStatus.module.scss"
import { RENEW_ENSO_STATUS } from "../../constants/constants";
import { getUserTypeCode } from "../../../../../service/authService";
import { getRemsMeainListExcelDownload } from "../../../../../service/monitor/renewStatService";
import { useLoading } from "../../../../../context/LoadingContext";

function Enso({ img, title, children }) {
	return (
		<div className={styles.enso}>
			<div className={styles.enso__img}>
				<img src={img} alt=""/>
			</div>
			<div className={styles.enso__content}>
				<div className={styles.enso__head}>{title}</div>
				<div className={styles.enso__body}>
					{children}
				</div>
			</div>
		</div>
	);
}

function EnsoItem({ title, value, deci, unit }) {
	return (
		<div className={styles['enso-item']}>
			<div className={styles['enso-item__head']}>{title}</div>
			<div className={styles['enso-item__body']}>
				<span className={styles['enso-item__value']}>
					<CountUp end={value} separator="," duration={1.5} decimals={deci} redraw={true} />
				</span>
				<span className={styles['enso-item__unit']}>{unit}</span>
			</div>
		</div>
	)
}

export default function EnsoStatus({ data, bizType }) {
	const loginUserTypeCode = getUserTypeCode();
	const { setLoading } = useLoading();

	return (
		<div className={styles.block}>
			<div className={styles.block__head}>
				<div className={styles.block__title}>에너지원별 현황</div>
					{[2003, 2005].includes(loginUserTypeCode) && bizType === 'bpm' && (
						<button
							className={styles.excel}
							onClick={() => {
								setLoading(true);
								getRemsMeainListExcelDownload(() => setLoading(false));
							}}
						>
							<img src="/images/excel.svg" alt="" style={{marginRight:'5px'}} />
							엑셀 다운로드
						</button>
					)}
			</div>

			<div className={styles.block__body}>
				{data?.map((item) => {
					const formattedData = RENEW_ENSO_STATUS[item.ensoTypeCode];
					return (						
						<Enso key={item.ensoTypeCode} title={formattedData.title} img={formattedData.img}>
							<EnsoItem title="설비 개수" value={item.cnt} unit="개" deci={0}/>
							<EnsoItem title="설비 용량" value={item.instCapa} unit={formattedData.instCapaUnit} deci={1}/>
							<EnsoItem title={formattedData.geneTerm} value={item.dayPower} unit="MWh" deci={1}/>
						</Enso>
					)
				})}
			</div>
		</div>
	)
}